import analyticsMiddleware from "./analytics.middleware";

const middlewaresLoader = () => (next) => (action) => {
  // ... Leave here your custom redux middleware
  analyticsMiddleware(action);
  next(action);
};

export default middlewaresLoader;
